import React from "react";

function SelectionContainer({
  children,
  title,
  subtitle,
  textAlign = "left",
  textSmallScreenAlign = "left",
}) {
  const convertTitle = (string) => {
    if (typeof string === "string") {
      return [string];
    } else {
      return string;
    }
  };

  return (
    <div className="selection-container">
      <div
        className={`pb-5 pt-2 text-sm-${textSmallScreenAlign} text-md-${textAlign} w-100`}>
        <div className={`${subtitle ? "mb-2" : ""}`}>
          {convertTitle(title)?.map((string, idx) => {
            return <h2 key={idx}>{string}</h2>;
          })}
        </div>
        {convertTitle(subtitle) && (
          <div className="subtitle">
            {convertTitle(subtitle)?.map((string, idx) => {
              return (
                <h4 key={idx} className="fw-normal w-100">
                  {string}
                </h4>
              );
            })}
          </div>
        )}
      </div>
      {children}
    </div>
  );
}

export default SelectionContainer;
